import React, { useContext } from 'react';
import i18n from './../i18n';
import { Select } from '@mui/material';
import { SettingsContext } from '../context';

/**
 * LanguageChanger Component. Possability for user to change UI-language.
 */
export default function LanguageChanger() {
  const { language, setLanguage } = useContext(SettingsContext);
  function changeLanguage(e: any) {
    setLanguage(e.target.value);
    i18n.changeLanguage(e.target.value);
  }

  return (
    <Select
      native
      value={language}
      onChange={changeLanguage}
      variant="standard"
    >
      <option value="en">English</option>
      <option value="ru">Русский</option>
    </Select>
  );
}
